// extracted by mini-css-extract-plugin
module.exports = {"test":"style_test__3iG-5"};